import React from "react";
import { NavLink } from "react-router-dom";
import logoImg from "../logo.svg";
import { Icon } from "react-icons-kit";
import { menu } from "react-icons-kit/feather/menu";
import { arrowLeft } from "react-icons-kit/feather/arrowLeft";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import axios from "axios";
import { useJwt } from "react-jwt";
import {
  GetAllMedia,
  GetCategoryImage,
  GetProductStatus,
  GetSliderById,
  UpdateSlider,
  api_url,
} from "../apiconfig/authService";
import { RiLoaderFill } from "react-icons/ri";
import { toast } from "react-toastify";

function EditSlider(props) {
  const navigate = useNavigate();
  const { _, isExpired } = useJwt(localStorage.getItem("accessToken"));
  if (isExpired) navigate("/");

  const setMediaTableViewMessage = props.setMessage;

  const [statusid, setStatusid] = useState(1);
  const [selectedMedias, setSelectedMedias] = useState([]);
  const [sliderTitle, setSliderTitle] = useState("");

  const [editedStatusid, setEditedStatusid] = useState(1);
  const [editedSelectedMedias, setEditedSelectedMedias] = useState([]);
  const [editedSliderTitle, setEditedSliderTitle] = useState("");

  const [mediaData, setMediaData] = useState([]);
  const [statusData, setStatusData] = useState(null);

  const { sliderid } = useParams();
  const [loading, setLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  

  const handleSliderTitleChange = (e) => {
    setEditedSliderTitle(e.target.value);
  };

  const handleStatusIdChange = (e) => {
    setEditedStatusid(e.target.value);
  };

  const handleImageClick = (mediaid) => {
    const isSelected = editedSelectedMedias.some((item) => item === mediaid);

    if (isSelected) {
      setEditedSelectedMedias(
        editedSelectedMedias.filter((item) => item !== mediaid)
      );
    } else {
      setEditedSelectedMedias([...editedSelectedMedias, mediaid]);
    }
  };

  const handleDiscardClick = () => {
    setEditedStatusid(statusid);
    setEditedSliderTitle(sliderTitle);
    setEditedSelectedMedias([...selectedMedias]);
    navigate("/slider");
  };

  const handleSubmitClick = async (e) => {
    e.preventDefault();

    try {
      if (editedSliderTitle === "") {
        toast.error("Slider title is required!");
        return;
      }
      if (editedSelectedMedias.length === 0) {
        toast.error("Slider image is required!");
        return;
      }
    } catch (error) {
      toast.error(error.message);
      window.scrollTo(0, 0);
      return;
    }

    let response;
    const requestBody = {
      sliderid,
      title: editedSliderTitle,
      relatedMedias: editedSelectedMedias,
      statusid: editedStatusid,
    };
    try {
      setEditLoading(true);
      response = await UpdateSlider(
        requestBody,
        localStorage.getItem("accessToken")
      );
      if (response.status === 200) {
        setEditLoading(false);
        toast.success("Slider Updated Successfully");
        setMediaTableViewMessage(response.data.message);
        navigate("/slider");
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        setEditLoading(false);
        toast.error(err.response.data.error);
        window.scrollTo(0, 0);
      } else {
        toast.error("An error occurred. Please try again later.");
        window.scrollTo(0, 0);
      }
    } finally {
      setEditLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const statusResponse = await GetProductStatus(
          localStorage.getItem("accessToken")
        );
        setLoading(false);
        setStatusData(statusResponse.data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    })();
    (async () => {
      setLoading(true);
      try {
        const mediaResponse = await GetAllMedia(
          localStorage.getItem("accessToken")
        );
        setLoading(false);
        setMediaData(mediaResponse.data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    })();
    (async () => {
      setLoading(true);
      try {
        const response = await GetSliderById(
          sliderid,
          localStorage.getItem("accessToken")
        );
        setLoading(false);
        setSliderTitle(response.data._doc.title);
        setStatusid(response.data._doc.statusid);
        setSelectedMedias([...response.data._doc.relatedMedias]);
        setEditedSliderTitle(response.data._doc.title);
        setEditedStatusid(response.data._doc.statusid);
        setEditedSelectedMedias([...response.data._doc.relatedMedias]);
      } catch (error) {
        console.log(error);
      } finally {
       setLoading(false); 
      }
    })();
  }, []);

  return (
    <div className="dashboard-content">
      <Sidebar />
      {/* <div className="mobileOption d-flex align-items-center justify-content-between">
          <div  className="buyMore">
            <img className="img-fluid" src={logoImg} alt=""/>
          </div>
          <button className="btn btn-primary offCanvasToggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling"><Icon className="menu" icon={menu} size={25}/></button>
        </div> */}
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">Edit Slider</h1>
          <div className="d-inline-flex gap-2">
            <NavLink to="/slider" className="btn btn-primary">
              View All
            </NavLink>
          </div>
        </div>
        {loading ? (
          <div className="d-flex align-items-center justify-content-center">
            <RiLoaderFill
              size={40}
              className="text-success spin-animation text-center"
            />
          </div>
        ) : (
          <div
            role="tabpanel"
            className="personal-info tab-pane active storetab"
            id="pi"
          >
            {/* <h4 className="text-primary h6 fw-bold mb-3">Product main category information</h4> */}
            <div className="row">
              <div className="form-group col-sm-12 col-lg-12 mb-3">
                {/* <div className="form-floating mb-4"> */}
                <label htmlFor="catName">Slider Title</label>
                <input
                  type="text"
                  value={editedSliderTitle || ""}
                  onChange={handleSliderTitleChange}
                  className="form-control custom-input my-3"
                  id="catName"
                  placeholder="Slider Title"
                />
                {/* </div> */}
              </div>
            </div>
            {/* <div className="form-floating mb-4"> */}
            <label htmlFor="floatingInput">Status</label>
            <select
              className="form-select custom-input my-3"
              onChange={handleStatusIdChange}
              value={editedStatusid || ""}
            >
              {statusData?.map((item, index) => (
                <option value={item.statusid} key={index}>
                  {item.status}
                </option>
              ))}
            </select>
            {/* </div> */}
            <div className="row">
              {mediaData?.map((item, index) => (
                <div className="col-lg-2" key={index}>
                  <input
                    className="form-check-input"
                    onChange={() => handleImageClick(item?.mediaid)}
                    checked={editedSelectedMedias.includes(item?.mediaid)}
                    type="checkbox"
                  />
                  <img
                    width="100px"
                    height="100px"
                    onClick={() => handleImageClick(item.mediaid)}
                    style={{
                      marginLeft: 20,
                      marginRight: 20,
                      marginBottom: 20,
                    }}
                    src={`${api_url}/product/category/getCategoryImage/${item.image}`}
                  />
                </div>
              ))}
            </div>
            <div className="row">
              <div
                className="col-12 d-flex"
                style={{ height: "40px", width: "120px" }}
              >
                <button
                  type="submit"
                  onClick={handleDiscardClick}
                  disabled={editLoading}
                  style={{ height: "100%", width: "100%" }}
                  className="btn btn-danger save-btn text-uppercase"
                >
                  Discard
                </button>{" "}
                &nbsp;
                {editLoading ? (
                  <div
                    className="btn btn-primary loader-active save-btn"
                    style={{ height: "100%", width: "100%" }}
                  >
                    <RiLoaderFill
                      size={20}
                      className="spin-animation"
                      color="white"
                    />
                  </div>
                ) : (
                  <button
                    type="submit"
                    disabled={editLoading}
                    onClick={handleSubmitClick}
                    className="btn btn-primary save-btn text-uppercase"
                    style={{ height: "100%", width: "100%" }}
                  >
                    Save
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
        <hr />
      </div>
    </div>
  );
}
export default EditSlider;
